import { Component, OnInit } from '@angular/core';
import { DateRangeInterval } from '@app/core/components/date-range/date-range.component';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions, GridRow } from '@app/core/components/grid/grid.types';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';
import { RememberService } from '@app/core/services/remember.service';
import { BusinesscoItem, LogisticService } from '@app/services/logistic.service';
import { SearchProjectItem, TypeaheadService } from '@app/services/typeahead.service';

@Component({
    selector: 'tt-interbranch-equipment-invoicing',
    templateUrl: './interbranch-equipment-invoicing.component.html',
    styleUrls: ['./interbranch-equipment-invoicing.component.css'],
})
export class InterbranchEquipmentInvoicingComponent implements OnInit {
    public companies: BusinesscoItem[] = [];

    public get?: InterbranchEquipmentInvoicingGet;

    public selectGrid?: GridOptions;

    public showGrid?: GridOptions;

    constructor(
        private datatask: DataTaskService,
        private logistic: LogisticService,
        private typeahead: TypeaheadService,
        private remember: RememberService,
        private modal: ModalService,
    ) {}

    public projectSelected(event?: SearchProjectItem) {
        if (!!this.get && ((!!event && !!event.item_id && !!event.item_name) || !event)) {
            this.get.project_keyno = event?.item_id ? '' + event.item_id : '0';
            this.get.project_name = event?.item_name || '';

            this.remember.remember('w_interbranchequipmentinvoicing.project_keyno', this.get.project_keyno);
            this.remember.remember('w_interbranchequipmentinvoicing.project_name', this.get.project_name);
        }
    }

    public readGrid() {
        if (this.get?.selected_tab === 'select') {
            this.selectGrid?.gridfunc?.read?.();
        } else if (this.get?.selected_tab === 'show') {
            this.saveSelectedRows();
        }
    }

    public searchProjects = async () => {
        if (!!this.get) {
            return this.typeahead.searchProjects({ project_name: this.get.project_name, businessco_no: this.get.businessco_no });
        }

        throw Error('page not completed loading');
    };

    private async loadGet() {
        this.get = (await this.datatask.Post(3613))[0];

        this.createGrids();
    }

    private async loadCompanies() {
        this.companies = await this.logistic.getCompanies();
    }

    private createGrids() {
        if (!!this.get) {
            this.selectGrid = new Grid()
                .setRememberId('interbranchequipmentinvoicing.select.grid')
                .setLoadDataFunction({ method: 3612, parameters: () => this.get })
                .setKendoConfig({ aggregate: true });
            this.showGrid = new Grid()
                .setRememberId('interbranchequipmentinvoicing.show.grid')
                .setLoadDataFunction({ method: 3614, parameters: () => ({ ...this.get, records: this.getSelectedPowtimesList(this.selectGrid?.gridfunc?.getIsSelectedRows() ?? []) }) })
                .setKendoConfig({ aggregate: true });
        }
    }

    private getSelectedPowtimesList(rows: GridRow[]): { powtime_keyno: any; is_selected: any }[] {
        return rows.map((row) => ({ powtime_keyno: row['powtime_keyno'], is_selected: row['is_selected'] })) ?? [];
    }

    private async saveSelectedRows() {
        if (!!this.selectGrid?.gridfunc && !!this.get) {
            const selectedRows = this.getSelectedPowtimesList(this.selectGrid.gridfunc.getAllRows());

            try {
                this.showGrid?.gridfunc?.gridProgress(true);

                const request: InterbranchEquipmentInvoicingGet & { records: { powtime_keyno: any; is_selected: any }[] } = { ...this.get, records: selectedRows };
                const response = (await this.datatask.Post(3618, request))[0];

                if (response.errorcode !== '0') {
                    this.modal.show({ type: 'warning', title: 'Varsel', message: response.errormessage });
                } else {
                    await this.showGrid?.gridfunc?.read?.();
                }
            } finally {
                this.showGrid?.gridfunc?.gridProgress(false);
            }
        }
    }

    ngOnInit(): void {
        this.loadGet();
        this.loadCompanies();
    }
}

interface InterbranchEquipmentInvoicingGet {
    businessco_no: string;
    businessco_equipment: string;
    project_keyno: string;
    project_name: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    invoice_date: string;
    show_invoiced: '1' | '0';
    selected_tab: string;
}
